import { Typography } from '@mui/material';
import { formatToAmount } from '@qrios/frontend-library';

import WithFormLayout from '../../../../../common/with-form-layout';

import { apiMethodMapper } from '../utils';
import { AddFundsToTheWalletOrder } from '../interfaces';
import { DialogError } from '../../../../../common/business-error';

interface Props {
  addFundsOrderData: AddFundsToTheWalletOrder;
  loading: boolean;
  error: DialogError;
  onClose: () => void;
  onSubmit: () => void;
}

const AddingFundsOrderSummary = ({ addFundsOrderData, onClose, onSubmit, loading, error }: Props) => {
  const method = apiMethodMapper(addFundsOrderData.method);
  const amount = formatToAmount(addFundsOrderData.amount);

  return (
    <WithFormLayout
      submitLabel="Confirm the transfer order"
      secondaryLabel="Back"
      onSubmit={onSubmit}
      onSecondary={onClose}
      loading={loading}
      error={error}
    >
      <Typography pb={3}>
        You want to add <b>{amount}</b> to your wallet, using <b>{method}</b> payment method.
      </Typography>
    </WithFormLayout>
  );
};
export default AddingFundsOrderSummary;
